<template>
  <div id="container">
    <div class="item-box-content">
      <div>
        <span class="bold"></span>
        <span class="basic">备货信息</span>
      </div>
      <!-------------- 备货信息 -------------->
      <stock-up-message
        ref="stockupMessageRefs"
        :InfoList="InfoList"
        :id="cusId"
        :orderContractReceive="orderContractReceive"
        :storageBaseList="storageBaseList"
        :VoList="VoList"
        :type="type"
      ></stock-up-message>
    </div>
    <div class="box-table" style="margin-top:20px">
      <div class="title-font-style">
        <span>备货清单</span>
      </div>
      <el-table
        style="margin-top:20px"
        border
        :data="list"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        max-height="378"
      >
        <el-table-column label="合同编号" width="150" show-overflow-tooltip fixed>
          <template slot-scope="scope">
            <span class="approval" @click="toHeTong(scope.row)">{{scope.row.contractCode}}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户合同编号" prop="customerContractCode" width="120"></el-table-column>
        <el-table-column label="签订时间" width="125">
          <template slot-scope="scope">{{scope.row.signingTime|dateFilterL}}</template>
        </el-table-column>
        <el-table-column label="客户名称" min-width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="toKeHu(scope.row)"
            >{{scope.row.customerName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="品牌" prop="brandName" show-overflow-tooltip></el-table-column>
        <el-table-column label="型号" show-overflow-tooltip>
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="onProductDetail(scope.row)"
            >{{ scope.row.model }}</div>
          </template>
        </el-table-column>
        <el-table-column label="订货号" prop="orderNumber" show-overflow-tooltip></el-table-column>
        <el-table-column label="货期" show-overflow-tooltip>
          <template slot-scope="scope">{{scope.row.ocExtime}}天</template>
        </el-table-column>
        <el-table-column label="数量" prop="count" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <div class="footer-but">
      <el-button type="primary" @click="startStockUp">发起备货</el-button>
    </div>
    <open-or-close
      @onUpdataState="onUpdataState"
      :content="content"
      title="确认备货"
      ref="openOrCloseRefs"
    ></open-or-close>
  </div>
</template>
<script>
import stockUpMessage from './stockUp/stockUpMessage'
import {
  saleInitiateStockup,
  queryCustomerMsg,
  saleInitiateStockupAadd
} from '@/api/sell/sellManage'
import { houseInformation } from '@/api/storage/storage'
import OpenOrClose from '@/components/OpenOrClose/index'
export default {
  components: {
    'open-or-close': OpenOrClose,
    'stock-up-message': stockUpMessage
  },
  data() {
    return {
      cusId: '',
      stockupMessage: {}, // 备货信息
      orderContractReceive: {}, // 默认收货对象
      VoList: [], // 发货人列表
      InfoList: [], // 发货人列表
      storageBaseList: [], // 备货仓库
      list: this.$store.state.Sell.tempBotList,
      type: '', // 备货方式
      flag: true, // true 直接配货 false 审批
      content: '备货发起后无法撤回，是否确认备货？'
    }
  },
  mounted() {
    if (this.$store.state.Sell.tempBotList.length !== 0) {
      this.type = this.$route.query.type
      this.list.forEach((m) => (m.stockType = this.type))
      if (this.$route.query.cusId) {
        this.cusId = this.$route.query.cusId
        queryCustomerMsg(this.cusId).then((res) => {
          if (res.data.code === 200) {
            this.orderContractReceive = res.data.obj.customerRecevieInfo
            this.VoList = res.data.obj.customerRecevieMobileList
            this.InfoList = res.data.obj.customerRecevieInfoList
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        houseInformation().then((res) => {
          if (res.data.code === 200) {
            this.storageBaseList = res.data.obj
          }
        })
      }
    } else {
      this.$router.push({ name: 'sellStockRecord' })
    }
  },
  methods: {
    onUpdataState() {
      // 弹框确认
      const obj = {
        ...this.$refs.stockupMessageRefs.queryParams,
        deliverDate: this.stockupMessage.deliveryTime,
        hbType: this.stockupMessage.stockupType,
        customerRecevieMobileList: this.$refs.stockupMessageRefs.queryParams,
        customerRecevieInfo: this.$refs.stockupMessageRefs.consigneeParams,
        notInStockList: this.list
      }
      saleInitiateStockupAadd(this.flag, obj).then((res) => {
        if (res.data.code === 200) {
          const str = this.flag
            ? '已发起备货，请等待配货！'
            : '已发起备货审核，请等待审核！'
          this.$message.success(str)
          this.$router.push({ name: 'sellStockRecord' })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    startStockUp() {
      this.stockupMessage = {
        ...this.$refs.stockupMessageRefs.queryParams,
        ...this.$refs.stockupMessageRefs.consigneeParams
      }
      if (this.stockupMessage.deliveryTime) {
        if (
          this.stockupMessage.stockupType === '入库备货' &&
          !this.stockupMessage.storageId
        ) {
          this.$message.error('请填写完整备货信息!')
          return
        }
        if (this.stockupMessage.stockupType === '直发备货') {
          if (
            !this.stockupMessage.crName ||
            !this.stockupMessage.crPhone ||
            !this.stockupMessage.sendPeople ||
            !this.stockupMessage.sendPhone
          ) {
            this.$message.error('请填写完整备货信息!')
            return
          }
        }
      } else {
        this.$message.error('请选择预计发货时间!')
        return
      }
      saleInitiateStockup(this.list).then((res) => {
        if (res.data.code === 200) {
          this.flag = res.data.obj
          this.content = this.flag
            ? '备货发起后无法撤回，是否确认备货？'
            : '备货产品中存在不满足备货条件的产品，需提交上级审核，是否确认提交？'
          this.$refs.openOrCloseRefs.onInitial()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onProductDetail(row) {
      this.$router.push({ name: 'productDetails', query: { id: row.proId } })
    },
    toHeTong(row) {
      this.$router.push({
        name: 'contractEdit',
        query: { id: row.contractId, cusId: row.customerId }
      })
    },
    toKeHu(row) {
      this.$router.push({
        path: '/crm/customer/details',
        query: { id: row.customerId }
      })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
